import { useCallback, useState } from 'react';

export const useShippingAddress = () => {
  const [isUpdateOpen, setIsUpdateOpen] = useState<boolean>(false);

  const onUpdateModalOpen = useCallback(() => {
    setIsUpdateOpen(true);
  }, []);
  const onUpdateModalClose = useCallback(() => {
    setIsUpdateOpen(false);
  }, []);

  return {
    isUpdateOpen,
    onUpdateModalOpen,
    onUpdateModalClose,
  };
};
